import { Columns } from 'react-bulma-components';
import Player from '../components/Player/Player';
// t.ex. src/Pages/MidiPage.jsx
import React from 'react';

const MidiPage = () => {
  return (
      <Columns>
{        <Columns.Column>
          <Player
            playerId="p1"
            midiUrl="/midi/Blue Bossa.mid"

          />
        </Columns.Column>}

        <Columns.Column>
          <Player
            playerId="p2"
            midiUrl="/midi/Blue Bossa.mid"
            transpose={-2}
            midiEditor={true}
            chooseFile={true}
          />
        </Columns.Column>
      </Columns>
  );
};

      {/*  <MusicEngineProvider >{/* soundFontUrl="../GeneralUserGS.sf3"> <Player playerId="p3" midiUrl="/midi/BlueBossa.mid" midiEditor /> */}
export default MidiPage;
